import { render, staticRenderFns } from "./BrazilMap.vue?vue&type=template&id=6765720c&scoped=true"
import script from "./BrazilMap.vue?vue&type=script&lang=js"
export * from "./BrazilMap.vue?vue&type=script&lang=js"
import style0 from "./BrazilMap.vue?vue&type=style&index=0&id=6765720c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765720c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6765720c')) {
      api.createRecord('6765720c', component.options)
    } else {
      api.reload('6765720c', component.options)
    }
    module.hot.accept("./BrazilMap.vue?vue&type=template&id=6765720c&scoped=true", function () {
      api.rerender('6765720c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/collectionOperationDashboard/component/BrazilMap.vue"
export default component.exports